export default __webpack_public_path__ + "static/media/eggmoon.baf9144d.jpeg";